import axios from 'axios'

class ConvenienceFeeFactory {
  async convenienceFee () {
    try {
      const url = '/convenience_fee'
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async createConvenienceFee (data: any) {
    try {
      const url = '/convenience_fee'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async updateConvenienceFee (id: any, data: any) {
    try {
      const url = `/convenience_fee/${id}`
      const response = await axios.put(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const convenienceFeeFactory = new ConvenienceFeeFactory()
